import React from 'react';
import { Image, NativeModules, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import Clipboard from '@react-native-clipboard/clipboard';
import { MessageSchema } from '../../realm/schema';
import { color_333333, white } from '../../assets/style/colors';
import { ImageSourcePropType } from 'react-native/Libraries/Image/Image';
import RNFS from 'react-native-fs';

import {
	Str_AddEmoticons,
	Str_CancelTranslate,
	Str_Collect,
	Str_Copy,
	Str_CopyFail,
	Str_CopySuc,
	Str_Delete,
	Str_Forward,
	Str_Locate,
	Str_Multi,
	Str_Quote,
	Str_Receiver,
	Str_Speaker,
	Str_Translate,
	Str_Withdraw,
} from '../../language/string_res';
import { MessageType } from '../../constants/types';
import { getMsgTranslate, getUid } from '../../store/token';

import { Menu, MenuOptions, MenuTrigger, renderers } from '../../components/popupmenu';
import { Meta } from '../../../imsdk/db/t_msg';
import { func } from 'prop-types';
import { showToast } from '../../components/Toast';
import { isIos } from '../../AppEvent';
import { hideLoading, showLoading } from '../../components/Loading';
import { ClipboardUtil } from '../../utils/ClipboardUtils';

interface ChatPopMenuProps {
	children: React.ReactNode;
	message?: MessageSchema;
	quote?: Meta;
	onMenuClick?(value: string): void; // 单击事件
	showPopover: boolean;
	setShowPopover: React.Dispatch<React.SetStateAction<boolean>>;
	popoverPosition?: { x: number; y: number };
	translate?: string;
}

export type PopoverItem = {
	value: string;
	label: string;
	icon: ImageSourcePropType;
};

const MenusItem: React.FC<PopoverItem & { handleClick: (value: string) => void }> = ({ value, label, icon, handleClick }) => {
	return (
		<TouchableOpacity
			activeOpacity={1}
			onPress={() => handleClick(value)}
			style={[styles.popoverItem, { width: value === 'Locate' ? 90 : 70 }]}
		>
			{value === 'Quote' ? (
				<View
					style={{
						width: 16,
						height: 16,
						backgroundColor: white,
						alignItems: 'center',
						justifyContent: 'center',
						borderRadius: 20,
						marginBottom: 8,
					}}
				>
					<Image source={icon} style={{ width: 12, height: 12 }} />
				</View>
			) : (
				<Image source={icon} tintColor={white} style={{ width: 18, height: 18, marginBottom: 8 }} />
			)}
			<Text style={{ color: white, fontSize: 12, textAlign: 'center', paddingHorizontal: 1 }}>{label}</Text>
		</TouchableOpacity>
	);
};

export const ChatPopMenu: React.FC<ChatPopMenuProps> = ({
	children,
	message,
	quote,
	onMenuClick,
	showPopover,
	setShowPopover,
	popoverPosition,
	translate,
}) => {
	let items: PopoverItem[] = [];

	if (message) {
		items = [];
		// 音视频通话消息不可转发和引用
		if (!(message.type === MessageType.RTC_VOICE || message.type === MessageType.RTC_VIDEO)) {
			items = [
				{ value: 'Quote', label: Str_Quote, icon: require('../../assets/image/icon_quote.png') },
				{ value: 'Forward', label: Str_Forward, icon: require('../../assets/image/icon_forward.png') },
			];
		}
		items = [...items, ...getMenuItems(message)];
	} else if (quote) {
		// 定位图标
		items.push({ value: 'Locate', label: Str_Locate, icon: require('../../assets/image/icon_msg_local.png') });
	}

	function getMenuItems(message: MessageSchema): PopoverItem[] {
		let items: PopoverItem[] = [];
		if (message.type === MessageType.TEXT) {
			items.push({ value: 'Copy', label: Str_Copy, icon: require('../../assets/image/icon_msg_copy.png') });
			if (getMsgTranslate() === 1 && message.mid) {
				if (translate && translate.length > 0) {
					items.push({
						value: 'CancelTranslate',
						label: Str_CancelTranslate,
						icon: require('../../assets/image/icon_switch_language.png'),
					});
				} else {
					items.push({
						value: 'Translate',
						label: Str_Translate,
						icon: require('../../assets/image/icon_switch_language.png'),
					});
				}
			}
		}
		if (message.type === MessageType.IMAGE && message.mid && message.mid.length > 0) {
			items.push({ value: 'Copy', label: Str_Copy, icon: require('../../assets/image/icon_msg_copy.png') });
			items.push({ value: 'AddEmoticon', label: Str_AddEmoticons, icon: require('../../assets/image/icon_collect.png') });
		}
		if (message.mid && message.mid.length > 0) {
			items.push({ value: 'Delete', label: Str_Delete, icon: require('../../assets/image/icon_msg_del.png') });

			if (message.type !== MessageType.RTC_VOICE && message.type !== MessageType.RTC_VIDEO) {
				items.push({ value: 'Multi', label: Str_Multi, icon: require('../../assets/image/icon_multi.png') });
				items.push({ value: 'Collect', label: Str_Collect, icon: require('../../assets/image/icon_collect.png') });
			}

		}
		const sendSUc = message.send_statue === '0' || message.send_statue === '1';
		if (
			!(message.type === MessageType.RTC_VIDEO || message.type === MessageType.RTC_VOICE) &&
			message.mid && message.mid.length > 0 &&
			message.sender === getUid() &&
			!sendSUc &&
			message.stime &&
			Date.now() - message.stime <= 60 * 2 * 1000
		) {
			items.push({ value: 'Withdraw', label: Str_Withdraw, icon: require('../../assets/image/icon_msg_callback.png') });
		}
		if (message.type === MessageType.VOICE) {
			// if (PlayerManager.isReceiver) {
			// 	items.push({ value: 'Speaker', label: Str_Speaker, icon: require('../../assets/image/icon_speaker.png') });
			// } else {
			// 	items.push({ value: 'Receiver', label: Str_Receiver, icon: require('../../assets/image/icon_receiver.png') });
			// }
		}

		if (message.send_statue === '1') {
			items = [{ value: 'Delete', label: Str_Delete, icon: require('../../assets/image/icon_msg_del.png') }];
		}

		return items;
	}

	// 复制图片到剪切板（支持远程 url 与本地文件，使用 data URI 作为通用 fallback）
	async function copyImageToClipboard(message: MessageSchema) {
		showLoading()
		// 尝试从常见字段获取图片 uri（根据你的消息结构调整）
		const maybeUri = message.upload_path || message.thumbnailPath || message.content || '';
		if (!maybeUri) throw new Error('no-image-uri');
		if (!RNFS.exists(maybeUri)) {
			throw new Error('image-file is no exists');
		}

		let path = maybeUri;
		try {
			let isSucc = false;
			// 远程 http/https 地址 -> 下载到缓存再读取 base64
			if (/^https?:\/\//i.test(maybeUri)) {
				path = `${RNFS.CachesDirectoryPath}/chat_img_${Date.now()}`;
				const dl = await RNFS.downloadFile({ fromUrl: maybeUri, toFile: path, background: true }).promise;
				if (!dl || !dl.statusCode || dl.statusCode < 200 || dl.statusCode >= 300) {
					throw new Error(`download-failed:${dl && dl.statusCode}`);
				}

				if (isIos) {
					const base64 = await RNFS.readFile(path, 'base64');
					// 清理临时文件
					await RNFS.unlink(path).catch(() => { });
					if (!base64) throw new Error('read-base64-failed');
					isSucc = await ClipboardUtil.setImage(base64)
				} else {
					isSucc = await ClipboardUtil.setImage(path)
					// 清理临时文件
					await RNFS.unlink(path).catch(() => { });
				}
			} else {
				// 本地路径（可能带 file:// 前缀）
				if (path.startsWith('file://')) path = path.replace(/^file:\/\//i, '');
				// RNFS 不能直接读取 content:// URI，若遇到则尝试提示用户
				if (path.startsWith('content://')) {
					throw new Error('content-uri-not-supported');
				}

				if (isIos) {
					const base64 = await RNFS.readFile(path, 'base64');
					if (!base64) throw new Error('read-base64-failed');
					isSucc = await ClipboardUtil.setImage(base64)
				} else {
					isSucc = await ClipboardUtil.setImage(path)
					// 清理临时文件
					await RNFS.unlink(path).catch(() => { });
				}
			}

			if (isSucc) {
				hideLoading()
				// 提示
				showToast(Str_CopySuc);
			} else {
				hideLoading()
				showToast(Str_CopyFail);
			}
		} catch (err) {
			hideLoading()
			showToast(Str_CopyFail);
			if (path.includes("chat_img_")) {
				RNFS.unlink(path).catch(() => { });
			}
		}
	}

	function handlePopMenuItemClick(value: string) {
		if (value === 'Copy') {
			if (message) {
				if (message.type === MessageType.IMAGE) {
					copyImageToClipboard(message);
				} else if (message.type === MessageType.TEXT) {
					Clipboard.setString(message.content);
					showToast(Str_CopySuc)
				}
			}
		} else {
			onMenuClick?.(value);
		}
		setShowPopover(false);
	}

	return (
		<Menu
			opened={showPopover}
			onBackdropPress={() => setShowPopover(false)}
			style={{ flexDirection: 'row' }}
			renderer={renderers.Popover}
			rendererProps={{
				preferredPlacement: 'top',
				placement: 'top',
				anchorPosition: popoverPosition,
				anchorStyle: { backgroundColor: color_333333 },
			}}
		>
			<MenuTrigger
				style={{ opacity: 1 }}
				customStyles={{
					triggerOuterWrapper: { opacity: 1 },
					triggerWrapper: { opacity: 1 },
				}}
				triggerOnLongPress
			>
				{children}
			</MenuTrigger>
			<MenuOptions
				optionsContainerStyle={{
					borderRadius: 12,
					backgroundColor: color_333333,
					paddingBottom: 8,
				}}
			>
				<View style={[styles.popoverContent, { borderTopRightRadius: 12, borderTopLeftRadius: 12 }]}>
					{items.slice(0, 4).map((item) => {
						return (
							<MenusItem key={item.value} value={item.value} label={item.label} icon={item.icon} handleClick={handlePopMenuItemClick} />
						);
					})}
				</View>
				<View style={[styles.popoverContent, { borderBottomRightRadius: 12, borderBottomLeftRadius: 12 }]}>
					{items.slice(4, items.length).map((item) => {
						return (
							<MenusItem key={item.value} value={item.value} label={item.label} icon={item.icon} handleClick={handlePopMenuItemClick} />
						);
					})}
				</View>
			</MenuOptions>
		</Menu>
	);
};

const styles = StyleSheet.create({
	popoverContainer: {
		backgroundColor: color_333333,
		borderRadius: 10,
		paddingHorizontal: 10,
		paddingBottom: 10,
	},
	popoverContent: {
		backgroundColor: color_333333,
		flexDirection: 'row',
	},
	popoverItem: {
		paddingHorizontal: 5,
		alignItems: 'center',
		paddingTop: 10,
	},
});
